<ngx-spinner
  size="large"
  color="#fff"
  type="ball-clip-rotate-multiple"
  bdColor="rgba(51, 51, 51, 0.7)"
>
  <p style="color: white">Loading...</p>
</ngx-spinner>

<router-outlet></router-outlet>
